import { types } from "@gadgetinc/mobx-quick-tree";
import { contentHash } from "../../utils";
import { ShopifyBasePartnerAppConfig } from "./ShopifyBasePartnerAppConfig";
import { EnvironmentNameMSTType, type LegacyEnvironmentName } from "../../Environment";

/**
 * See packages/state-trees/src/connections/ShopifyConnectionConfig.ts for documentation
 * on the different types of Shopify configurations
 */
export const ShopifyLegacyPartnerAppConfig = ShopifyBasePartnerAppConfig("ShopifyAppConfig")
  .props({
    environment: EnvironmentNameMSTType,
    customRedirectURL: types.array(types.string),
    isCli: types.optional(types.boolean, false),
  })
  .views((self) => ({
    get appURL() {
      return self.customRedirectURL.slice().sort()[0];
    },
    get contentHash() {
      return contentHash([
        self.apiKey,
        self.apiSecretKey,
        self.environment,
        ...self.customRedirectURL.slice().sort(),
        self.isCli,
        self.appId,
        self.appName,
      ]);
    },
  }))
  .actions((self) => ({
    setEnvironment(value: LegacyEnvironmentName) {
      self.environment = value;
    },
    setCustomRedirectUrl(value?: string) {
      self.customRedirectURL.replace(value ? [value] : []);
    },
    setIsCli(value: boolean) {
      self.isCli = value;
    },
  }))
  .actions((self) => ({
    setAppURL(value?: string) {
      self.setCustomRedirectUrl(value);
    },
  }));
